module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-page"
  }, [_c('div', {
    staticStyle: {
      "margin": "0 auto",
      "text-align": "center"
    }
  }, [_c('ul', [(_vm.current > 1) ? _c('li', [_c('a', {
    staticClass: "m-wid",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.setCurrent(_vm.current - 1)
      }
    }
  }, [_vm._v("上一页")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.grouplist), function(index) {
    return _c('li', [_c('a', {
      class: {
        'm-active': _vm.current == index.val
      },
      attrs: {
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          return _vm.setCurrent(index.val)
        }
      }
    }, [_vm._v(_vm._s(index.text))])])
  }), _vm._v(" "), (_vm.current < _vm.pageNum) ? _c('li', [_c('a', {
    staticClass: "m-wid",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.setCurrent(_vm.current + 1)
      }
    }
  }, [_vm._v("下一页")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "m-wid"
  }, [_vm._v("共" + _vm._s(_vm.pageNum) + "页")])])], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03c6917d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/Page.vue
// module id = 130
// module chunks = 2 4 6